import { useState } from 'react';
import { MarkerF, InfoWindowF } from '@react-google-maps/api';

const CustomMapMarker = ({ location, onClick, allowTooltipShown, customerType }) => {

  const [showInfoWindow, setShowInfoWindow] = useState(false);

  const handleClick = () => {
    if (onClick) {
      onClick(location);
    }
  }

  const handleMouseOver = () => {
    setShowInfoWindow(true);
  };

  const handleMouseOut = () => {
    setShowInfoWindow(false);
  };

  const getIcon = () => {
    if (!location.active) {
        return {
            url: process.env.REACT_APP_ASSET_PATH + '/icons/maps-marker.svg',            
            scaledSize: new window.google.maps.Size(38, 46),
        };
    }
    else {
        return {
            url: process.env.REACT_APP_ASSET_PATH + '/icons/maps-marker-center.svg',
            scaledSize: new window.google.maps.Size(38, 46),
        };
    }
  };

  return (
    <>
      <MarkerF
      position={{ lat: location.lat, lng: location.lng }}
      icon={getIcon()}
      onClick={handleClick}
      onMouseOver={handleMouseOver}
      onMouseOut={handleMouseOut}
      />
      {showInfoWindow && allowTooltipShown && (
        <InfoWindowF position={{ lat: location.lat, lng: location.lng }} options={{ zIndex: 5, pixelOffset: new window.google.maps.Size(0, -47), headerDisabled: true }}>
          {/* <div>{customerType ? location.name : 'Bitte wählen Sie zwischen Privatkunde und Unternehmen'}</div> */}
          <div>{location.name}</div>
        </InfoWindowF>
      )}
    </>
  );
};

export default CustomMapMarker;
